<template>
	<div class="form-background max-width-750 pd-bottom-lg">
		<Spin :spinning="isLoading">
			<TypographyTitle :level="3">{{ $t('rover-page.roverNetworkSettingHeader') }}</TypographyTitle>
			<Descriptions :column="1" size="middle" bordered class="bg-white">
				<DescriptionsItem :label="$t('rover-page.roverNetworkSettings.network_external_caster_address')">
					<div class="nobr">{{ roverSettings != null ? (roverSettings.network_external_caster_address || $t('common.noData')) : '' }}</div>
				</DescriptionsItem>
				<DescriptionsItem :label="$t('rover-page.roverNetworkSettings.network_mountpoint_brdc')">
					<div class="nobr">{{ roverSettings != null ? (roverSettings.network_mountpoint_brdc || $t('common.noData')) : '' }}</div>
				</DescriptionsItem>
				<DescriptionsItem :label="$t('rover-page.roverNetworkSettings.network_mountpoint_cssr')">
					<div class="nobr">{{ roverSettings != null ? (roverSettings.network_mountpoint_cssr || $t('common.noData')) : '' }}</div>
				</DescriptionsItem>
				<DescriptionsItem :label="$t('rover-page.roverNetworkSettings.network_mountpoint_near')">
					<div class="nobr">{{ roverSettings != null ? (roverSettings.network_mountpoint_near || $t('common.noData')) : '' }}</div>
				</DescriptionsItem>
			</Descriptions>
		</Spin>
	</div>
</template>

<script>
import { ref, onMounted } from 'vue';
import { TypographyTitle, Button, Form, FormItem, Input, Spin, Descriptions, DescriptionsItem } from 'ant-design-vue';

import Api from '@/api/Api';

import { showErrorMessage } from '@/components/common/errorMessage';


export default {
	components: {
		TypographyTitle, Button, Form, FormItem, Input, Spin, Descriptions, DescriptionsItem,
	},
	setup(props) {
		const roverSettings = ref(null);
		const isLoading = ref(true);
		onMounted(() => {
			Api.roverGetSettings(
				response => {
					isLoading.value = false;
					if (response.status === 'ok') {
						roverSettings.value = response.settings;
					} else {
						showErrorMessage(response.errors);
					}
				},
			);
		});
		return {
			isLoading,
			roverSettings,
		};
	},
}
</script>
